import React from "react";
import { TextInput, Create, SimpleForm, SelectInput } from "react-admin";

export default (props) => (
  <Create {...props}>
    <SimpleForm warnWhenUnsavedChanges sx={{ maxWidth: 500 }}>
      <TextInput source="fromName" isRequired fullWidth />
      <TextInput source="fromEmail" isRequired fullWidth />
      <TextInput source="fromBounceEmail" isRequired fullWidth />
      <TextInput source="url" fullWidth helperText="QR / view-pass base URL" />
      <TextInput
        source="templateId"
        fullWidth
        helperText="Optional Zepto template key (legacy batch path)"
      />
      <SelectInput
        source="type"
        choices={[{ id: "CONFIRMATION", name: "CONFIRMATION" }]}
        defaultValue="CONFIRMATION"
        isRequired
        fullWidth
      />
    </SimpleForm>
  </Create>
);
